<article class="subscription">
  @if (!isChangingSubscription && !isAddingAdditionalServices && !isChangingUser && !isChangingSimCard) {
    <section class="subscription-info">
      <div class="existing-info">
        <div>
          <div class="label">Status</div>
          <div>
            {{
              VoiceProduct.isActivationInProgress(product)
                ? product.subscription.isPortingNumber
                  ? 'Overføres til Ice'
                  : 'Aktiveres '
                : 'Aktivt siden'
            }}
            {{ product.subscription.activeSince | date: 'dd.MM.yyyy' }}
          </div>
        </div>
        <div>
          <div class="label">Bruker av abonnement</div>
          @if (product.isLoadingExistingSubscriber) {
            <app-spinner />
          } @else {
            <div>{{ product.subscriber.name }}</div>
            <div>Fødselsdato: {{ product.subscriber.birthday | date: 'dd.MM.yyyy' }}</div>
            <div>Email: {{ product.subscriber.email }}</div>
            <div>
              Adresse: {{ product.subscriber.address }}, {{ product.subscriber.postCode }}, {{ product.subscriber.city }}
            </div>
          }
        </div>
        <div>
          <div class="label">SIM-kort</div>
          <div>Hoved-SIM: {{ product.subscription.icc }}</div>
        </div>
        <div>
          <div class="label">Tilleggstjenester</div>
          @if (product.isLoadingSubscriptionDetails) {
            <app-spinner size="medium" />
          } @else {
            @if (getActiveAndSuspendedServices(); as activeServices) {
              @if (activeServices.length > 0 || !!assignedVasProduct) {
                <span class="additional-service">
                  @for (service of activeServices; track service.productId + $index) {
                    <app-ice-pill
                      cursor="default"
                      [type]="service.serviceStatus === ServiceStatus.ActiveUntilEndDate ? 'neutral' : 'primary'"
                    >
                      <span class="additional-service-details">
                        {{ service.description }}
                        @if (service.serviceStatus === ServiceStatus.ActiveUntilEndDate && service.endDate) {
                          <span class="active-to-date">aktiv til {{ service.endDate | date: 'dd.MM.yy' }}</span>
                        } @else {
                          <span class="price-per-month">
                            {{ service.price.includingVAT | priceFormat: PriceType.Monthly }}
                          </span>
                        }
                      </span>
                    </app-ice-pill>
                  }
                  @if (!!assignedVasProduct) {
                    <app-ice-pill class="vas-offering-information" type="neutral" [type]="'primary'">
                      {{ assignedVasProduct.productName }}
                      <span>
                        @if (assignedVasProduct.monthlyPrice?.price?.includingVAT > 0) {
                          <span class="price-per-month">&ensp;+</span>
                        }
                        <span class="price-per-month">
                          {{
                            assignedVasProduct.monthlyPrice?.price?.includingVAT
                              | priceFormat: PriceType.Monthly : 'Inkludert'
                          }}
                        </span>
                      </span>
                    </app-ice-pill>
                  }
                </span>
              } @else {
                Ingen
              }
            }
          }
          <div class="services-list"></div>
        </div>
      </div>
      <div class="buttons">
        <app-small-card-button
          testId="change-subscription-link"
          [isDisabled]="isOfferingUpgradeDisabled"
          [matTooltip]="isOfferingUpgradeDisabled ? SubscriptionNotActiveTooltip : ''"
          [name]="'Endre abonnement'"
          (click)="!isOfferingUpgradeDisabled && changeSubscription(product)"
          (keydown.enter)="!isOfferingUpgradeDisabled && changeSubscription(product)"
        />
        <app-small-card-button
          testId="change-subscription-user-link"
          [isDisabled]="isChangeUserDisabled"
          [matTooltip]="isChangeUserDisabled ? SubscriptionNotActiveTooltip : ''"
          [name]="'Endre bruker'"
          (click)="!isChangeUserDisabled && onChangeSubscriptionUser()"
          (keydown.enter)="!isChangeUserDisabled && onChangeSubscriptionUser()"
        />
        <app-small-card-button
          testId="change-additional-services-link"
          [isDisabled]="isAddAdditionalServicesDisabled"
          [matTooltip]="isAddAdditionalServicesDisabled ? SubscriptionNotActiveTooltip : ''"
          [name]="'Tilleggstjenester'"
          (click)="!isAddAdditionalServicesDisabled && onAddAdditionalServices()"
          (keydown.enter)="!isAddAdditionalServicesDisabled && onAddAdditionalServices()"
        />
        <app-small-card-button
          testId="change-sim-card-link"
          [isDisabled]="isReplacementSimDisabled"
          [matTooltip]="isReplacementSimDisabled ? ReplacementSimTooltip : ''"
          [name]="'Bytt SIM-kort'"
          (click)="!isReplacementSimDisabled && onChangeSimCard()"
          (keydown.enter)="!isReplacementSimDisabled && onChangeSimCard()"
        />
      </div>
    </section>
  }
  @if (isChangingSubscription) {
    <section>
      <app-change-subscription [product]="product" (finishedSelection)="onChangeSubscriptionClose()" />
    </section>
  }
  @if (isAddingAdditionalServices) {
    <section>
      <app-change-additional-services
        [isLoadingAdditionalServiceOfferings]="isLoadingAdditionalServiceOfferings()"
        [product]="product"
        (finishedChanging)="onAddAdditionalServicesClose()"
      />
    </section>
  }
  @if (isChangingUser) {
    <section>
      <app-change-user [product]="product" (finishedChanging)="onChangeUserClose()" />
    </section>
  }
  @if (isChangingSimCard) {
    <section>
      <app-change-sim-card [product]="product" (finishedChanging)="onChangeSimCardClose()" />
    </section>
  }
</article>
